module.exports = __webpack_public_path__ + "img/logo.e89f94c2.png";